import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { CollegePrintComponent } from '../college-print/college-print.component';
import { CollegeCapacityDiallogBoxComponent } from '../college-capacity-diallog-box/college-capacity-diallog-box.component';

@Component({
  selector: 'app-college-capacity',
  templateUrl: './college-capacity.component.html',
  styleUrls: ['./college-capacity.component.scss']
})
export class CollegeCapacityComponent implements OnInit {

  collegedataList = [];
  list = true;
  CollegeDataSearchForm;
  APIService: any;
  CgS1CentBoolean = true;
  CgOnlyCentBoolean = true;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  UniCollege
  UserCollege
  userPermission
  setIntervalSearch: any;
  blockCheck:any;

  constructor(
    public umsService: UmsService,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.CollegeDataSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
    this.getCollegeData();
    this.fetchSecretData();
  }

    fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      const result = res.projectPharam['ActiveFlow']
      let data = []
      data = JSON.parse(result)
      this.blockCheck = data[0].CollegeBlockCapacity;
    }
    );
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getCollegeData();
    this.keypress();
  }

  getCollegeData() {
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['CgOnlyCent'] = 1;
    payload['CgCode'] = this.UserCollege
    this.umsService.getCollege(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.collegedataList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else {
        this.collegedataList = [];
        this.spinner.hide();
      }

    }, (ERROR: HttpErrorResponse) => {
      this.collegedataList = [];
      this.spinner.hide();
    })
  }


  keypress() {
    if (this.setIntervalSearch) {
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(() => {
      this.spinner.show()
      this.collegedataList = [];
      const payload = {};
      payload['SearchString'] = this.CollegeDataSearchForm.value['SearchString']
      payload['PageSize'] = this.pageSize;
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.searchCollege(payload).subscribe((res) => {
        if (res.status) {
          this.spinner.hide()
          this.collegedataList = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else {
          this.spinner.hide()
          this.collegedataList = [];
          this.totalItems = 0
        }

      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
        this.collegedataList = [];
        this.totalItems = 0
      });
    }, 1000)

  }



  submitCapacity(collegedata: any) {
    const dialogRef = this.dialog.open(CollegeCapacityDiallogBoxComponent, {
      width: '110vh',
      data: { selected: collegedata, key: "cap" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCollegeData();
      this.CollegeDataSearchForm.controls['SearchString'].setValue('');
    });
  }

  submitBlock(collegedata: any) {
    const dialogRef = this.dialog.open(CollegeCapacityDiallogBoxComponent, {
      width: '110vh',
      data: { selected: collegedata, key: "blk" },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCollegeData();
      this.CollegeDataSearchForm.controls['SearchString'].setValue('');
    });
  }

  Print() {
    const dialogRef = this.dialog.open(CollegePrintComponent, {
      width: '100vh',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getCollegeData();
      this.CollegeDataSearchForm.controls['SearchString'].setValue('');
    });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

}
